module.exports = "<div class=\"swagger-container\"></div>\n"